var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonthly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24.000000pt",
    height: "24.000000pt",
    viewBox: "0 0 24.000000 24.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,24.000000) scale(0.100000,-0.100000)",
    fill: "",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47 211 c-15 -15 -17 -32 -15 -97 l3 -79 85 0 85 0 3 79 c3 71 1 81 -19 99 -15 14 -24 17 -27 9 -4 -14 -82 -16 -82 -2 0 15 -13 11 -33 -9z m143 -31 c0 -6 -30 -10 -70 -10 -40 0 -70 4 -70 10 0 6 30 10 70 10 40 0 70 -4 70 -10z m0 -80 l0 -50 -70 0 -70 0 0 50 0 50 70 0 70 0 0 -50z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthly);
export default __webpack_public_path__ + "static/media/monthly.3b891052d1538e076fcdd2fdb102cc09.svg";
export { ForwardRef as ReactComponent };